import { createSlice } from "@reduxjs/toolkit";

 const trigger = createSlice({
    name : 'trigger',
    initialState:{
        isOpen: false
    },
    reducers:{
        openNav : (state) => {
            state.isOpen = true
        },
        closeNav : (state) => {
            state.isOpen = false
        }
    }
})

export const { openNav, closeNav } = trigger.actions
export default trigger.reducer